import { motion } from "motion/react";

export const TermsBgSVG = () => {
    return (
        <svg
            className="hero-kaaba-svg"
            viewBox="0 0 520 340"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            style={{ overflow: "visible" }}
        >
            {/* Ground */}
            <motion.rect
                x="0" y="300" width="520" height="40" fill="white"
                initial={{ scaleX: 0, originX: "50%" }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            />

            {/* Outer plaza ring */}
            <motion.rect
                x="30" y="260" width="460" height="44" rx="2" fill="white" opacity="0.5"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                style={{ transformOrigin: "260px 282px" }}
                transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}
            />

            {/* Inner plaza ring */}
            <motion.rect
                x="80" y="230" width="360" height="74" rx="2" fill="white" opacity="0.6"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                style={{ transformOrigin: "260px 267px" }}
                transition={{ duration: 0.7, delay: 0.25, ease: "easeOut" }}
            />

            {/* Kaaba body */}
            <motion.rect
                x="180" y="130" width="160" height="170" rx="3" fill="white"
                initial={{ scaleY: 0 }}
                animate={{ scaleY: 1 }}
                style={{ transformOrigin: "260px 300px" }}
                transition={{ duration: 0.9, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
            />

            {/* Kaaba roof highlight */}
            <motion.rect
                x="180" y="130" width="160" height="28" rx="3" fill="white" opacity="0.6"
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.6 }}
                transition={{ duration: 0.6, delay: 1.1 }}
            />

            {/* Kiswa band */}
            <motion.rect
                x="180" y="178" width="160" height="16" fill="white" opacity="0.45"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                style={{ transformOrigin: "260px 186px" }}
                transition={{ duration: 0.5, delay: 1.2, ease: "easeOut" }}
            />

            {/* Door */}
            <motion.rect
                x="225" y="235" width="70" height="65" rx="3" fill="white" opacity="0.35"
                initial={{ scaleY: 0 }}
                animate={{ scaleY: 1 }}
                style={{ transformOrigin: "260px 300px" }}
                transition={{ duration: 0.5, delay: 1.3, ease: "easeOut" }}
            />

            {/* Door arch */}
            <motion.path
                d="M225 255 Q260 230 295 255"
                stroke="white" strokeWidth="2" fill="none" opacity="0.5"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 0.6, delay: 1.5, ease: "easeOut" }}
            />

            {/* Left main minaret */}
            <motion.rect
                x="90" y="80" width="22" height="180" rx="3" fill="white" opacity="0.7"
                initial={{ scaleY: 0 }}
                animate={{ scaleY: 1 }}
                style={{ transformOrigin: "101px 260px" }}
                transition={{ duration: 0.8, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
            />
            <motion.polygon
                points="90,80 112,80 101,50"
                fill="white" opacity="0.7"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 0.7, y: 0 }}
                transition={{ duration: 0.4, delay: 1.1 }}
            />

            {/* Left minaret rings */}
            {[120, 160, 200].map((y, i) => (
                <motion.rect
                    key={`lring-${i}`}
                    x="85" y={y} width="32" height="10" rx="2" fill="white" opacity="0.5"
                    initial={{ scaleX: 0 }}
                    animate={{ scaleX: 1 }}
                    style={{ transformOrigin: `101px ${y + 5}px` }}
                    transition={{ duration: 0.3, delay: 1.0 + i * 0.08, ease: "easeOut" }}
                />
            ))}

            {/* Right main minaret */}
            <motion.rect
                x="408" y="80" width="22" height="180" rx="3" fill="white" opacity="0.7"
                initial={{ scaleY: 0 }}
                animate={{ scaleY: 1 }}
                style={{ transformOrigin: "419px 260px" }}
                transition={{ duration: 0.8, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
            />
            <motion.polygon
                points="408,80 430,80 419,50"
                fill="white" opacity="0.7"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 0.7, y: 0 }}
                transition={{ duration: 0.4, delay: 1.1 }}
            />

            {/* Right minaret rings */}
            {[120, 160, 200].map((y, i) => (
                <motion.rect
                    key={`rring-${i}`}
                    x="403" y={y} width="32" height="10" rx="2" fill="white" opacity="0.5"
                    initial={{ scaleX: 0 }}
                    animate={{ scaleX: 1 }}
                    style={{ transformOrigin: `419px ${y + 5}px` }}
                    transition={{ duration: 0.3, delay: 1.0 + i * 0.08, ease: "easeOut" }}
                />
            ))}

            {/* Left small minaret */}
            <motion.rect
                x="145" y="120" width="16" height="140" rx="2" fill="white" opacity="0.5"
                initial={{ scaleY: 0 }}
                animate={{ scaleY: 1 }}
                style={{ transformOrigin: "153px 260px" }}
                transition={{ duration: 0.7, delay: 0.65, ease: [0.16, 1, 0.3, 1] }}
            />
            <motion.polygon
                points="145,120 161,120 153,100"
                fill="white" opacity="0.5"
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 0.5, y: 0 }}
                transition={{ duration: 0.4, delay: 1.15 }}
            />

            {/* Right small minaret */}
            <motion.rect
                x="359" y="120" width="16" height="140" rx="2" fill="white" opacity="0.5"
                initial={{ scaleY: 0 }}
                animate={{ scaleY: 1 }}
                style={{ transformOrigin: "367px 260px" }}
                transition={{ duration: 0.7, delay: 0.65, ease: [0.16, 1, 0.3, 1] }}
            />
            <motion.polygon
                points="359,120 375,120 367,100"
                fill="white" opacity="0.5"
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 0.5, y: 0 }}
                transition={{ duration: 0.4, delay: 1.15 }}
            />

            {/* Crescent moon */}
            <motion.path
                d="M267 118 Q280 102 295 118 Q283 110 270 118 Z"
                fill="white" opacity="0.8"
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 0.8, scale: 1 }}
                style={{ transformOrigin: "281px 110px" }}
                transition={{ duration: 0.5, delay: 1.55, ease: "backOut" }}
            />

            {/* Moon circle */}
            <motion.circle
                cx="278" cy="112" r="7" fill="white" opacity="0.7"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                style={{ transformOrigin: "278px 112px" }}
                transition={{ duration: 0.4, delay: 1.5, ease: "backOut" }}
            />

            {/* Moon shadow */}
            <motion.circle
                cx="284" cy="108" r="4" fill="rgba(100,55,10,1)" opacity="0.8"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                style={{ transformOrigin: "284px 108px" }}
                transition={{ duration: 0.4, delay: 1.65, ease: "backOut" }}
            />

            {/* Ambient shimmer on Kaaba — subtle breathing glow */}
            <motion.rect
                x="180" y="130" width="160" height="170" rx="3"
                fill="white"
                initial={{ opacity: 0 }}
                animate={{ opacity: [0, 0.06, 0] }}
                transition={{ duration: 3, delay: 2.2, repeat: Infinity, ease: "easeInOut" }}
            />
        </svg>
    );
};

